import React from "react";
import {
  Card,
  Box,
  Grid,
  Skeleton,
  Stack,
  Divider,
} from "@mui/material";
import { colors, borderRadiusPx, customShadows } from "../../../../../theme";

const GiftCardDetailSkeleton = () => {
  return (
    <Box sx={{ width: "100%" }}>
      {/* Header Skeleton */}
      <Card
        sx={{
          p: { xs: 2.5, sm: 3.5 },
          borderRadius: borderRadiusPx.xl,
          backgroundColor: colors.dashboard.cardBg,
          border: `1px solid ${colors.dashboard.cardBorder}`,
          boxShadow: customShadows.cardFlat,
          mb: 3.5,
        }}
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2.5}
          alignItems={{ xs: "flex-start", sm: "center" }}
          justifyContent="space-between"
        >
          <Stack spacing={1.5} sx={{ width: { xs: "100%", sm: "60%" } }}>
            <Stack direction="row" spacing={1}>
              <Skeleton variant="rounded" width={70} height={24} />
              <Skeleton variant="rounded" width={100} height={24} />
              <Skeleton variant="rounded" width={90} height={24} />
            </Stack>
            <Skeleton variant="text" width="80%" height={38} />
            <Skeleton variant="text" width="45%" height={20} />
          </Stack>
          <Skeleton variant="rounded" width={44} height={44} />
        </Stack>
      </Card>

      {/* Main Content Grid Skeleton */}
      <Grid container spacing={3.5}>
        {/* Left Column Skeleton */}
        <Grid item xs={12} md={7} lg={8}>
          {/* Visual Card Skeleton */}
          <Card
            sx={{
              borderRadius: borderRadiusPx.xl,
              backgroundColor: colors.dashboard.cardBg,
              border: `1px solid ${colors.dashboard.cardBorder}`,
              boxShadow: customShadows.cardFlat,
              overflow: "hidden",
            }}
          >
            <Skeleton
              variant="rectangular"
              width="100%"
              height={300}
              animation="wave"
            />
            <Box sx={{ p: 3 }}>
              <Skeleton variant="text" width="35%" height={28} sx={{ mb: 1.5 }} />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="90%" height={20} />
              <Skeleton variant="text" width="70%" height={20} />
              <Divider sx={{ my: 2 }} />
              <Skeleton variant="rounded" width="100%" height={60} />
            </Box>
          </Card>

          {/* Specs Skeleton */}
          <Card
            sx={{
              p: 3,
              borderRadius: borderRadiusPx.xl,
              backgroundColor: colors.dashboard.cardBg,
              border: `1px solid ${colors.dashboard.cardBorder}`,
              boxShadow: customShadows.cardFlat,
              mt: 3.5,
            }}
          >
            <Skeleton variant="text" width="40%" height={28} sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Skeleton variant="rounded" width="100%" height={70} />
              </Grid>
              <Grid item xs={6}>
                <Skeleton variant="rounded" width="100%" height={70} />
              </Grid>
              <Grid item xs={6}>
                <Skeleton variant="rounded" width="100%" height={70} />
              </Grid>
              <Grid item xs={6}>
                <Skeleton variant="rounded" width="100%" height={70} />
              </Grid>
            </Grid>
          </Card>
        </Grid>

        {/* Right Column Skeleton */}
        <Grid item xs={12} md={5} lg={4}>
          <Card
            sx={{
              p: 3,
              borderRadius: borderRadiusPx.xl,
              backgroundColor: colors.dashboard.cardBg,
              border: `1px solid ${colors.dashboard.cardBorder}`,
              boxShadow: customShadows.cardFlat,
            }}
          >
            <Stack spacing={2}>
              <Skeleton variant="text" width="60%" height={30} />
              <Divider />
              <Skeleton variant="rounded" width="100%" height={120} />
              <Skeleton variant="rounded" width="100%" height={48} />
              <Skeleton variant="text" width="70%" height={18} sx={{ mx: "auto" }} />
            </Stack>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default GiftCardDetailSkeleton;
